import React from 'react'
import NavBar from '../../components/NavBar'
import DashbaordContent from './dashboard'

function Dashboard (props) {
  return (
    <>
    <NavBar {...props}/>
    <DashbaordContent/>
    </>
  )
}
export default Dashboard
